import { makeAutoObservable } from 'mobx'
import type { ReactElement } from 'react'
import type { INormalizedApiError } from 'shared/api'

export class ErrorStore {
  constructor() {
    makeAutoObservable(this)
  }

  private _fieldsError: Record<string, string> | null = null

  private _fieldKeys: Set<string> | null = null

  get fieldsError() {
    return this._fieldsError
  }

  get fieldsErrorCommonText(): ReactElement[] | null {
    if (!this.fieldsError || !Object.keys(this.fieldsError).length) return null

    const entries = Object.entries(this.fieldsError)
    const commonEntries = this._fieldKeys
      ? entries.filter(([key]) => !this._fieldKeys?.has(key))
      : entries

    if (!commonEntries.length) return null

    const errors = commonEntries.map(([, value]) => value)
    return errors.map((error, index) => (
      <div
        key={index}
        style={{
          marginBottom: errors.length > 1 && index !== errors.length - 1 ? '8px' : 0,
        }}
      >
        {error}
      </div>
    ))
  }

  setFieldsError = (fieldError: Record<string, string> | null) => {
    this._fieldsError = fieldError
  }

  prepareFieldsErrorAndSave = (data: INormalizedApiError | null, fieldKeys?: string[]) => {
    this._fieldKeys = fieldKeys ? new Set(fieldKeys) : null

    if (!data) {
      this.setFieldsError(null)
      return
    }

    const result: Record<string, string> = {}

    data.keys().forEach((key) => {
      if (key.startsWith('business_information.') || key.startsWith('points_of_contact')) {
        const newKey = key.replace('business_information.', '').replace('points_of_contact.', '')
        result[newKey] = data.getError(key)
      } else {
        result[key] = data.getError(key)
      }
    })

    this.setFieldsError(result)
  }

  deleteErrorValue = (keyName: string) => {
    if (this.fieldsError) {
      delete this.fieldsError[keyName]
    }
  }

  reset = () => {
    this._fieldsError = null
    this._fieldKeys = null
  }
}
